import api from './api';

export const authService = {
    // Registro público (solo usuarios normales)
    register: async (userData) => {
        const response = await api.post('/auth/register-public', userData);
        return response.data;
    },

    // Registro de admin (solo para admin autenticados)
    registerAdmin: async (userData) => {
        const response = await api.post('/auth/register', userData);
        return response.data;
    },

    // Login
    login: async (credentials) => {
        const response = await api.post('/auth/login', credentials);
        const { access_token, user } = response.data;

        // Guardar token y usuario en localStorage
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('user', JSON.stringify(user));

        return response.data;
    },

    // Logout
    logout: () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
    },

    // Obtener usuario actual
    getCurrentUser: async () => {
        const response = await api.get('/auth/me');
        return response.data;
    },

    // Solicitar reset de contraseña
    requestPasswordReset: async (email) => {
        const response = await api.post('/auth/password-reset-request', { email });
        return response.data;
    },

    // Reset de contraseña
    resetPassword: async (token, newPassword) => {
        const response = await api.post('/auth/password-reset', {
            token,
            new_password: newPassword
        });
        return response.data;
    },

    // Eliminar cuenta (público, requerido por Play Store)
    deleteAccount: async (email, password) => {
        const response = await api.post('/auth/delete-account', { email, password });
        return response.data;
    },

    // Verificar si está autenticado
    isAuthenticated: () => {
        const token = localStorage.getItem('access_token');
        const user = localStorage.getItem('user');
        return !!(token && user);
    },

    // Obtener token
    getToken: () => {
        return localStorage.getItem('access_token');
    },

    // Obtener usuario desde localStorage
    getStoredUser: () => {
        const userStr = localStorage.getItem('user');
        return userStr ? JSON.parse(userStr) : null;
    }
};